import { ProductBlockDetails } from './components/ProductBlockDetails/index.js';
import { ProductBlockFooter } from './components/ProductBlockFooter/index.js';
import { ProductBlockHeader } from './components/ProductBlockHeader/index.js';
import { ProductBlockImages } from './components/ProductBlockImages/ProductBlockImages.js';
import { ProductBlockInner } from './components/ProductBlockInner/ProductBlockInner.js';
import { ProductBlockOuter } from './components/ProductBlockOuter/ProductBlockOuter.js';
import { ProductBlockPricing } from './components/ProductBlockPricing/ProductBlockPricing.js';
export { ProductBlockSlotsProvider, useProductBlockSlots } from './slots/context.js';

const ProductBlock = Object.assign({}, {
    Details: ProductBlockDetails,
    Footer: ProductBlockFooter,
    Header: ProductBlockHeader,
    Images: ProductBlockImages,
    Inner: ProductBlockInner,
    Outer: ProductBlockOuter,
    Pricing: ProductBlockPricing
});

export { ProductBlock };
//# sourceMappingURL=index.js.map
